import React from 'react';
import {Header, Breadcrumb, Loader, Segment, Tab, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Icon} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';
import Inscripcion from './Inscripcion';
import InscripcionLista from './InscripcionLista';
import ManageIndicadores from './ManageIndicadores';
import ManagePagosPendientes from './ManagePagosPendientes';


const ReportePanel=({id, ajaxCallInProgress, ventaInvMf, cambiarEstatus, errors=[],reporte, strings, cursoCombo, onChange,onChangeFiltro, datos, download, resultadosExamen, downloadExamen, pagos, onShowExamen, onShowAvance, onBuscar,usuario, estatusCombo,tipoPagoCombo, onSave, busqueda, inscripcionLista, fechas, usuarioCombo, tipomonedaCombo})=>{


     const panes = [
     {
        menuItem: 'Inscritos',
        render: () => 
              <div>

                <InscripcionLista
                        inscripcion={inscripcionLista}
                        pagos={pagos}
                        strings={strings}
                        onChange={onChangeFiltro}
                        download={download}
                    />    

             </div>
      },
    {
    menuItem: 'Inscribir',
    render: () => <Tab.Pane attached={false}>
       
                <Inscripcion
                    cambiarEstatus={cambiarEstatus}
                    reporte={reporte}
                    strings={strings}
                    cursoCombo={cursoCombo} 
                    onChange={onChange} 
                    datos={datos} 
                    onBuscar={onBuscar}
                    usuario={usuario}
                    errors={errors}
                    estatusCombo={estatusCombo}
                    tipoPagoCombo={tipoPagoCombo}
                    onSave={onSave}
                    busqueda={busqueda}
                    fechas={fechas}
                    usuarioCombo={usuarioCombo}
                    tipomonedaCombo={tipomonedaCombo}
                />
         </Tab.Pane>
  },
  {
         menuItem: 'Pagos pendientes',
        render: () => 
              <div>

                <ManagePagosPendientes
                    idCurso={datos.idCurso}
                    strings={strings}
                        

                    />    

             </div>
         },
    {
         menuItem: 'Indicadores',
        render: () => 
              <div>

                <ManageIndicadores
                    idCurso={datos.idCurso}
                    ventaInvMf={ventaInvMf}
                    strings={strings}
                        

                    />    

             </div>
         }     
 
]
 
	return (
        <div >
        
            <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
                <Loader size='big' inline content={strings?strings["Procesando"]:""}/>
            </Dimmer>

            <Header dividing>             
                <Header.Content>{strings?strings["Inscripcion"]:""}</Header.Content>
            </Header>

            <Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form >
                              <Form.Field  required  error={errors.cursoId}>
                              <label  >{strings?strings["Curso"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["Curso"]:""} 
                                    name="idCurso"
                                     fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.idCurso}
                                    options={cursoCombo}/>
                            </Form.Field>

                        
                         </Form>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        
            <br/>
        
            <div>
            <Tab menu={{ pointing: true }} panes={panes} /> 
            </div>
         
        </div>
	);
};



export default ReportePanel;